export default "__VITE_ASSET__nI8EJ0vE__"